import { ProductInCompatibility } from '@core/services/CompatibilityHandler/productInCompatibility';
import { Disco } from '../services/CompatibilityHandler/model/Disco';
import { PlacaVideo } from '../services/CompatibilityHandler/model/PlacaVideo';
import { Cpu } from '../services/CompatibilityHandler/model/Cpu';
import { CoolerCpu } from '../services/CompatibilityHandler/model/CoolerCpu';

import { Product } from './piramide/Product';
import {
  Fuente,
  Gabinete,
  Memoria,
  Monitor,
  Mother,
} from '@core/services/CompatibilityHandler/model';

export class ArmaPc {
  cpu: ProductInCompatibility<Cpu>[];
  ccpu: ProductInCompatibility<CoolerCpu>[];
  coolerfan: ProductInCompatibility<Product>[];
  auriculares: ProductInCompatibility<Product>[];
  card_reader: ProductInCompatibility<Product>[];
  celular: ProductInCompatibility<Product>[];
  fuente: ProductInCompatibility<Fuente>[];
  gab: ProductInCompatibility<Gabinete>[];
  hd: ProductInCompatibility<Disco>[];
  mem: ProductInCompatibility<Memoria>[];
  monitores: ProductInCompatibility<Monitor>[];
  mother: ProductInCompatibility<Mother>[];
  mouse: ProductInCompatibility<Product>[];
  mousepad: ProductInCompatibility<Product>[];
  notebooks: ProductInCompatibility<Product>[];
  opticos: ProductInCompatibility<Product>[];
  os: ProductInCompatibility<Product>[];
  pcday: ProductInCompatibility<Product>[];
  soportes: ProductInCompatibility<Product>[];
  teclados: ProductInCompatibility<Product>[];
  video: ProductInCompatibility<PlacaVideo>[];
  perifericos?: ProductInCompatibility<Product>[];
}
